import styled from "styled-components";

export const IntroductionVideoWrapper = styled.div`
    width: 100%;
    height: 100%;
    padding: 5px;
    box-sizing: border-box;
    letter-spacing: 1px;
`;
